import { render, staticRenderFns } from "./CreateDetailPopup.vue?vue&type=template&id=5c457504"
import script from "./CreateDetailPopup.vue?vue&type=script&lang=js"
export * from "./CreateDetailPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports